// Constants
import { PERSONAL_CHANNEL_SUFFIX } from './socketConstants';

export const getPersonalUserChannel = (userId) => `${userId}${PERSONAL_CHANNEL_SUFFIX}`;
